// Content hash for manuscript idempotency.
// Hashes the *normalised* text (NFC + lowercase + whitespace-collapsed), not raw
// PDF bytes — so a re-export of the same manuscript from EM with a different
// encoding still hits the same skim record.

export async function hashManuscriptText(text: string): Promise<string> {
  const normalised = text.normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim();
  const bytes = new TextEncoder().encode(normalised);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return bytesToHex(new Uint8Array(digest));
}

function bytesToHex(bytes: Uint8Array): string {
  const out: string[] = [];
  for (const b of bytes) out.push(b.toString(16).padStart(2, '0'));
  return out.join('');
}
